@if (caseCardItem) {
    <div
        class="card h-100"
        [attr.data-cy]="'carditem-' + caseCardItem?.id"
        [ngClass]="{
            'flex-row border-0': headerMode,
            'card-clickable': caseCardItem?.routerLink,
        }"
        [routerLink]="caseCardItem?.routerLink"
    >
        <div
            class="card-body d-flex min-w-0"
            [attr.data-cy]="'carditem-action-case-' + caseCardItem?.regarding"
            [ngClass]="{
                'flex-row me-2 p-0': headerMode,
                'flex-column': !headerMode,
            }"
        >
            <div class="d-flex flex-column flex-grow-1 text-truncate">
                <div class="d-flex flex-grow-1">
                    <div class="flex-grow-1 text-truncate">
                        @if (headerMode) {
                            <div
                                class="d-flex align-items-center fw-bold flex-row"
                            >
                                @if (caseCardItem?.avatars) {
                                    <molecule-avatar-group
                                        class="me-1"
                                        size="sm"
                                        [avatars]="caseCardItem?.avatars"
                                    ></molecule-avatar-group>
                                }
                                <div
                                    class="d-flex flex-column align-items-xl-center flex-xl-row text-truncate"
                                >
                                    <div class="divider-xl-end divider--short">
                                        <a
                                            [routerLink]="
                                                caseCardItem?.routerLink
                                            "
                                            [attr.data-cy]="
                                                'carditem-action-' +
                                                caseCardItem?.id
                                            "
                                        >
                                            {{
                                                caseCardItem?.subject
                                                    | translateTokenisedString
                                            }}
                                        </a>
                                    </div>
                                    <div
                                        class="d-flex align-items-center text-truncate"
                                    >
                                        @if (caseCardItem?.regarding) {
                                            <div class="text-truncate">
                                                <a
                                                    [class.divider-end]="
                                                        caseCardItem?.regarding
                                                    "
                                                    [routerLink]="
                                                        caseCardItem?.regardingRouterLink
                                                    "
                                                    [attr.data-cy]="
                                                        'carditem-action-' +
                                                        caseCardItem?.regarding
                                                    "
                                                    [title]="
                                                        caseCardItem?.regarding
                                                    "
                                                    [innerHTML]="
                                                        caseCardItem?.regarding
                                                    "
                                                >
                                                </a>
                                            </div>
                                        }
                                        <div>
                                            {{
                                                caseCardItem?.internalIdentifier
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="d-flex align-items-center">
                                <div
                                    class="small divider--short"
                                    [class.divider-end]="
                                        caseCardItem?.dateStarted
                                    "
                                >
                                    {{ caseCardItem?.internalIdentifier }}
                                </div>
                                <div class="small text-muted">
                                    {{ CREATED | translateTokenisedString }}
                                    {{
                                        caseCardItem?.dateStarted
                                            | displayDate
                                                : {
                                                      format: 'dd MMM yyyy',
                                                      locale: locale,
                                                  }
                                    }}
                                </div>
                            </div>
                            <div class="fw-bold text-truncate">
                                <a
                                    [routerLink]="caseCardItem?.routerLink"
                                    [attr.data-cy]="
                                        'carditem-action-' + caseCardItem?.id
                                    "
                                >
                                    {{
                                        caseCardItem?.subject
                                            | translateTokenisedString
                                    }}
                                </a>
                            </div>
                            <div class="small text-truncate">
                                @if (caseCardItem?.regarding) {
                                    <a
                                        [title]="caseCardItem?.regarding"
                                        [routerLink]="
                                            caseCardItem?.regardingRouterLink
                                        "
                                        [attr.data-cy]="
                                            'carditem-action-' +
                                            caseCardItem?.regarding
                                        "
                                        [innerHtml]="caseCardItem?.regarding"
                                    >
                                    </a>
                                }
                            </div>
                        }
                    </div>
                    @if (!headerMode) {
                        @if (
                            caseCardItem?.isSuggestedCardList &&
                            caseCardItem?.linkToEntityId
                        ) {
                            <molecule-action-button
                                class="ms-1"
                                [actionButton]="linkToActionButton"
                                (onClick)="onLinkToActionButtonClicked()"
                            ></molecule-action-button>
                        } @else {
                            <molecule-action-button
                                class="ms-1"
                                [actionButton]="contextMenuActionButton"
                                (selectMenuItem)="onContextMenuSelected($event)"
                            ></molecule-action-button>
                        }
                    }
                </div>
                @if (caseCardItem?.totalActivities > 0) {
                    <div class="mt-2">
                        <ngb-progressbar
                            [type]="caseCardItem?.severity"
                            [textType]="caseCardItem?.severity"
                            [value]="
                                (caseCardItem?.completion.completed /
                                    caseCardItem?.completion.total) *
                                100
                            "
                        ></ngb-progressbar>
                        @if (!headerMode && caseCardItem?.nextAction) {
                            <div>
                                <div
                                    class="d-flex align-items-center flex-shrink-0 mt-2"
                                >
                                    <wdx-icon
                                        class="me-1"
                                        [scale]="1"
                                        [ngClass]="{
                                            'text-danger':
                                                caseCardItem?.nextAction
                                                    ?.issueCount,
                                            'text-success':
                                                !caseCardItem?.nextAction
                                                    ?.issueCount,
                                        }"
                                        icon="flag"
                                        iconStyle="fas"
                                    ></wdx-icon>
                                    <div class="small">
                                        {{
                                            NEXT_ACTION
                                                | translateTokenisedString
                                        }}
                                    </div>
                                    <div
                                        class="small divider-start divider--short"
                                    >
                                        {{
                                            caseCardItem?.nextAction?.subject
                                                | translateTokenisedString
                                        }}
                                    </div>
                                    @if (caseCardItem?.nextAction?.issueCount) {
                                        <div class="d-flex align-items-center">
                                            <wdx-icon
                                                class="text-danger ms-1"
                                                [scale]="1"
                                                icon="comment"
                                                iconStyle="fas"
                                            ></wdx-icon>
                                            <div class="small ms-1">
                                                {{
                                                    caseCardItem?.nextAction
                                                        ?.issueCount
                                                }}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        <div class="d-flex mt-1">
                            <div
                                class="d-flex align-items-center"
                                [ngClass]="
                                    caseCardItem
                                        | fn: getStatusClass : headerMode
                                "
                            >
                                <wdx-icon
                                    class="justify-content-center align-items-center rounded-circle icon-container-size-xs"
                                    [icon]="
                                        CASE_COMPLETED_STATUS_ICON_MAP[
                                            caseCardItem?.completedStatus
                                        ]
                                    "
                                >
                                </wdx-icon>
                                <span class="small d-flex align-items-center">
                                    {{
                                        caseCardItem
                                            | fn
                                                : getStatusText
                                                : translationsService
                                    }}
                                    @if (caseCardItem | fn: hasStatusDate) {
                                        <span
                                            class="divider-start divider--short"
                                        >
                                            {{
                                                caseCardItem
                                                    | fn
                                                        : getStatusDate
                                                        : userFacadeService
                                            }}
                                        </span>
                                    }
                                </span>
                            </div>
                            <div class="flex-shrink-0 small">
                                {{ caseCardItem?.completion.completed }}/{{
                                    caseCardItem?.completion.total
                                }}
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
        @if (!headerMode) {
            <div class="card-footer d-flex">
                <div class="flex-grow-1">
                    <div class="d-flex align-items-center">
                        @if (caseCardItem?.avatars) {
                            <molecule-avatar-group
                                size="sm"
                                [avatars]="caseCardItem?.avatars"
                            ></molecule-avatar-group>
                        }
                    </div>
                </div>
                <div class="d-flex flex-row-reverse">
                    <wdx-toggle-button
                        size="sm"
                        [toggle]="caseCardItem?.isFavourite"
                        (wdxOnChange)="onToggleFavourite($event)"
                        (click)="$event.stopPropagation()"
                    ></wdx-toggle-button>
                </div>
            </div>
        }
        @if (
            !headerMode &&
            (caseCardItem?.status === CASE_STATUS_TYPE.Complete ||
                caseCardItem?.status === CASE_STATUS_TYPE.Cancelled)
        ) {
            <div
                class="d-flex align-items-center justify-content-between custom-card__footer"
            >
                <div class="d-flex align-items-center flex-grow-1 p-1 small">
                    @if (
                        caseCardItem?.completedStatus ===
                        COMPLETED_STATUS.Cancelled
                    ) {
                        {{
                            ALL_ACTIONS_ARE_CANCELLED | translateTokenisedString
                        }}
                    } @else {
                        {{ ALL_ACTIONS_COMPLETED | translateTokenisedString }}
                    }
                </div>
            </div>
        }
    </div>
}

<ng-container #assignLookupContainer></ng-container>
